import { useRouter } from "next/router";
import ArticleMiniCard from "@components/templates/ArticleMiniCard";
import SectionHeading from "@components/ui-components/SectionHeading";
import HrScroll from "@components/pages/feedPage/HrScroll";
import ArticleDataType from "@customTypes/articleData.type";
import * as clickhouse from "./ch-events";
import { useEffect, useRef, useState } from "react";
import OtherTrendingWidgetImageObserver from "@utils/otherTrendingWidgetImageObserver";

type TrendingArticlesProps = {
  trendingArticleList: Array<ArticleDataType>;
  page?: string;
};

const TrendingArticles = ({ trendingArticleList, page = "" }: TrendingArticlesProps) => {
  const router = useRouter();
  const { query } = useRouter();
  const { id } = query;
  const [otherTrendingObserver, setOtherTrendingObserver] = useState(null);

  const trendinArticlesWidgetRef = useRef(null);

  useEffect(() => {
    const trendingWidgetImageObserver = new OtherTrendingWidgetImageObserver({
      threshold: id ? 0.8 : 0.1
    });
    setOtherTrendingObserver(trendingWidgetImageObserver);

    if (
      trendingWidgetImageObserver &&
      trendinArticlesWidgetRef &&
      trendinArticlesWidgetRef.current
    ) {
      trendingWidgetImageObserver.observe(trendinArticlesWidgetRef.current);
      return () => {
        trendingWidgetImageObserver.destroy();
      };
    }
  }, []);
  const handleCardClick = (articledata) => {
    clickhouse.trackCTAs({
      element_name: "article_card",
      pageType: page === "news_details" ? page : "",
      data: {
        tag_id: articledata?.tagIds[0],
        selected_article_id: articledata.id,
        tag_name: articledata?.tags[0],
        article_id: id
      }
    });

    router.push(
      `/other_trending_reads?value=${articledata?.tags[0]}&articleId=${articledata?.id}&tagId=${articledata?.tagIds[0]}`
    );
  };

  return (
    <>
      {trendingArticleList && (
        <div
          id="trendinArticlesWidget"
          ref={trendinArticlesWidgetRef}
          className="bg-[#F3F8FF] py-5 dark:bg-DN050"
        >
          <SectionHeading className="pl-5">Other Trending Reads</SectionHeading>
          <HrScroll className="mt-4 pl-5 ">
            {trendingArticleList.map((articleData: any, index) => (
              <div key={index}>
                <ArticleMiniCard
                  articleData={articleData}
                  titleHref={`/other_trending_reads?value=${articleData?.tags[0]}&articleId=${articleData?.id}&tagId=${articleData?.tagIds[0]}`}
                  onCardClick={() => handleCardClick(articleData)}
                  observer={otherTrendingObserver}
                />
              </div>
            ))}
          </HrScroll>
        </div>
      )}
    </>
  );
};

export default TrendingArticles;
